module.exports = __webpack_public_path__ + "img/logo.a013c150.png";